import { useEffect, useState } from 'react';
// Import Store
import { useAppDispatch } from 'store';
import {
    addPageValidationScenarioFields,
    clearPageValidation,
    removePageValidationScenarioFields,
    setPageValidation,
} from 'store/slices/pageValidation';
// Import services
import { validationScenarios } from 'services';

export interface UseValidationReturn {
    addValidationProperties: (
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        data: any,
        editCloneMode?: Nilable<boolean>,
        addData?: AnyObject,
        additionalFields?: AnyObject,
    ) => void;
    removeValidationProperties: (fieldNames: string[]) => void;
    setValidationScenario: (data?: AnyObject) => void;
    clearValidationScenario: () => void;
    resetValidationScenario: () => void;
}

const useValidation = (
    pageName: string,
    setManually = false,
    pageType: Nilable<string> = undefined,
): UseValidationReturn => {
    const dispatch = useAppDispatch();
    const [state, setState] = useState({});

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(init, []);

    //eslint-disable-next-line @typescript-eslint/no-use-before-define
    function init() {
        !setManually && setValidationScenario();
    }

    function setValidationScenario(data: AnyObject = {}) {
        setState({ ...state, ...data });
        dispatch(setPageValidation(validationScenarios[pageName].scenario(data, pageType)));
    }

    function addValidationProperties(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        data: any,
        editCloneMode: Nilable<boolean> = undefined,
        addData: AnyObject = state,
        additionalFields: AnyObject = {},
    ) {
        const scenario = validationScenarios[pageName]?.propertiesCreator?.(
            data,
            editCloneMode,
            addData,
            additionalFields,
        );
        dispatch(addPageValidationScenarioFields(scenario));
    }

    function removeValidationProperties(fieldNames: string[]) {
        dispatch(removePageValidationScenarioFields(fieldNames));
    }

    function clearValidationScenario() {
        dispatch(clearPageValidation());
    }

    function resetValidationScenario() {
        dispatch(setPageValidation(validationScenarios[pageName].scenario(state, undefined)));
    }

    return {
        addValidationProperties,
        removeValidationProperties,
        clearValidationScenario,
        resetValidationScenario,
        setValidationScenario,
    };
};

export default useValidation;
